module.exports = __webpack_public_path__ + "static/img/logo_dapeng.af6c26a7.png";